<template>
    <b-card no-body class="p-3">
        <PreviewModal ref="preview_modal"></PreviewModal>
        <h2>{{ project.project_name }}</h2>
        <div class="row justify-content-between align-items-center">
            <div class="col-12 col-md-auto">
                <svg xmlns="http://www.w3.org/2000/svg" class="text-muted mr-1" width="16" height="16" viewBox="0 0 384 512"><path fill="currentColor" d="M215.7 499.2C267 435 384 279.4 384 192 384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2 12.3 15.3 35.1 15.3 47.4 0M192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128"/></svg>
                <el-tooltip :content="project.project_location">
                    <span class="text-xs mr-2">{{ project.project_location | shortenText(35) }}</span>
                </el-tooltip>
                <!-- <span class="text-primary cursor-pointer text-xs">View Map</span> -->
            </div>
            <div class="col-12 col-md-auto">
                <span class="text-xs text-muted">Starting from</span>
                <h3>RM {{ project.unit_lowest.unit_price | moneyFormatter }} to RM {{ project.unit_highest.unit_price | moneyFormatter }}</h3>
            </div>
            <div class="col-12">
                <span v-if="project.project_stage_id === 1" class="badge rounded-pill bg-primary text-white mr-3">Under Construction</span>
                <span v-else class="badge rounded-pill bg-primary text-white mr-3">Completed</span>
                <span class="text-muted text-sm">{{ project.project_type }} | </span>
                <span v-if="project.project_lease_type_id === 1" class="text-muted text-sm">Freehold</span>
                <span v-else class="text-muted text-sm">Leasehold</span>
                <hr class="my-3">
            </div>
        </div>
        <div class="row">
            <div class="col-auto">
                <div class="text-muted text-xs">Developer</div>
                <p v-if="project.project_source_type !== 'HESTIA'">{{ project.project_developer }}</p>
                <p v-else>{{ developerName(project) }}</p>
            </div>
            <div class="col-auto">
                <div class="text-muted text-xs">Listed Date</div>
                <p>{{ project.project_listed_date | dateFormatString }}</p>
            </div>
            <div class="col-auto">
                <div class="text-muted text-xs">Completion Date</div>
                <p>{{ project.project_completion_date | dateFormatString }}</p>
            </div>
        </div>

        <div v-if="project.project_source_type !== 'HESTIA'">
            <!-- style 1, got cover image and galleries-->
            <b-row no-gutters class="my-3" v-if="project.project_cover_image && project.project_galleries.length > 0">
                <b-col cols="12" md="9" class="pr-md-2">
                    <el-image v-if="project.project_cover_image" 
                        :src="project.project_cover_image" 
                        :alt="project.project_name" 
                        @click="$refs.preview_modal.preview(project.project_cover_image)" 
                        class="rounded cursor-pointer" style="width: 100%; height: 100%" fit="cover" 
                    />
                    <el-image v-else :src="failed" class="rounded" style="width: 100%; height: 100%" fit="cover" />
                </b-col>
                <b-col cols="12" md="3">
                    <img v-for="(image, index) in project.project_galleries" :key="index" 
                        :src="image.Upload_URL" 
                        alt="..."
                        :class="{'img-fluid rounded cursor-pointer': true, 'mb-2': index !== project.project_galleries.length - 1}"
                        @click="$refs.preview_modal.preview(image.Upload_URL)" 
                    >
                </b-col>
            </b-row>

            <!-- style 2, only got cover image -->
            <div class="my-3 d-flex justify-content-center" v-if="project.project_cover_image && project.project_galleries.length === 0">
                <img class="img-fluid rounded" :src="project.project_cover_image" :alt="project.project_name" v-if="project.project_cover_image" @click="$refs.preview_modal.preview(project.project_cover_image)">
            </div>
        </div>

        <div v-else>
            <b-row no-gutters class="my-3">
                <b-col cols="12" md="9" class="pr-md-2">
                    <el-image v-if="images[0]" :src="images[0].url" class="rounded cursor-pointer" style="width: 100%; height: 100%" fit="cover" @click="$refs.preview_modal.preview(images[0].url)" />
                    <el-image v-else :src="failed" class="rounded" style="width: 100%; height: 100%" fit="cover" />
                </b-col>
                <b-col cols="12" md="3">
                    <img v-for="(image, index) in images.slice(1, 4)" 
                    :key="index" 
                    :src="image ? image.url : failed" 
                    alt="..." 
                    :class="{'img-fluid rounded cursor-pointer': true, 'mb-2': index !== images.slice(1, 4).length - 1}"
                    @click="$refs.preview_modal.preview(image.url)"
                />
                </b-col>
            </b-row>
        </div>

        <h3>Description</h3>
        <p>{{ project.project_description }}</p>

        <b-row class="mt-3">
            <b-col cols="auto" class="text-center">
                <div class="circle">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 56 56"><path fill="currentColor" d="M5.29 21.994h5.613v-3.179c0-2.064 1.16-3.178 3.248-3.178h8.235c2.088 0 3.248 1.114 3.248 3.178v3.178h5.01v-3.178c0-2.064 1.16-3.178 3.364-3.178h7.725c2.204 0 3.364 1.114 3.364 3.178v3.178h5.614V15.66c0-4.106-2.18-6.193-6.17-6.193H11.46c-3.967 0-6.17 2.087-6.17 6.193ZM0 44.867c0 1.137.742 1.856 1.902 1.856h1.3c1.136 0 1.878-.72 1.878-1.856v-3.294c.255.07.998.116 1.531.116h42.8c.534 0 1.254-.047 1.509-.116v3.294c0 1.137.742 1.856 1.879 1.856h1.322c1.137 0 1.879-.72 1.879-1.856v-13.2c0-4.199-2.343-6.495-6.588-6.495H6.588C2.343 25.172 0 27.468 0 31.667Z"/></svg>
                </div>
                <div v-if="project.project_source_type !== 'HESTIA'">
                    <p class="text-center text-xs" v-if="project.unit_lowest.unit_type.bedroom === project.unit_highest.unit_type.bedroom">{{ project.unit_lowest.unit_type.bedroom }} bed</p>
                    <p class="text-center text-xs" v-else>{{ project.unit_lowest.unit_type.bedroom }} - {{ project.unit_highest.unit_type.bedroom }} bed</p>
                </div>
                <div v-else>
                    <p class="text-center text-xs" v-if="project_summary.min_bed === project_summary.max_bed">{{ project_summary.min_bed }} bed</p>
                    <p class="text-center text-xs" v-else>{{ project_summary.min_bed }} - {{ project_summary.max_bed }} bed</p>
                </div>
            </b-col>
            <b-col cols="auto" class="text-center">
                <div class="circle">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 512 512"><path fill="currentColor" d="M96 77.3C96 70 101.9 64 109.3 64c3.5 0 6.9 1.4 9.4 3.9l14.9 14.9c-3.6 9-5.6 18.9-5.6 29.2 0 19.9 7.2 38 19.2 52-5.3 9.2-4 21.1 3.8 29 9.4 9.4 24.6 9.4 33.9 0L289 89c9.4-9.4 9.4-24.6 0-33.9-7.9-7.9-19.8-9.1-29-3.8C246 39.2 227.9 32 208 32c-10.3 0-20.2 2-29.2 5.5l-14.9-14.9C149.4 8.1 129.7 0 109.3 0 66.6 0 32 34.6 32 77.3V256c-17.7 0-32 14.3-32 32s14.3 32 32 32h448c17.7 0 32-14.3 32-32s-14.3-32-32-32H96zM32 352v16c0 28.4 12.4 54 32 71.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-16h256v16c0 17.7 14.3 32 32 32s32-14.3 32-32v-40.4c19.6-17.6 32-43.1 32-71.6v-16z"/></svg>
                </div>
                <div v-if="project.project_source_type !== 'HESTIA'">
                    <p class="text-center text-xs" v-if="project.unit_lowest.unit_type.bathroom === project.unit_highest.unit_type.bathroom">{{ project.unit_lowest.unit_type.bathroom }} bed</p>
                    <p class="text-center text-xs" v-else>{{ project.unit_lowest.unit_type.bathroom }} - {{ project.unit_highest.unit_type.bathroom }} bath</p>
                </div>
                <div v-else>
                    <p class="text-center text-xs" v-if="project_summary.min_bath === project_summary.max_bath">{{ project_summary.min_bath }} bath</p>
                    <p class="text-center text-xs" v-else>{{ project_summary.min_bath }} - {{ project_summary.max_bath }} bath</p>
                </div>
            </b-col>
            <b-col cols="auto" class="text-center">
                <div class="circle">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 512 512"><path fill="currentColor" d="M135.2 117.4 109.1 192h293.8l-26.1-74.6c-4.5-12.8-16.6-21.4-30.2-21.4H165.4c-13.6 0-25.7 8.6-30.2 21.4m-95.6 79.4L74.8 96.3C88.3 57.8 124.6 32 165.4 32h181.2c40.8 0 77.1 25.8 90.6 64.3l35.2 100.5c23.2 9.6 39.6 32.5 39.6 59.2v192c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-48H96v48c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V256c0-26.7 16.4-49.6 39.6-59.2M128 288a32 32 0 1 0-64 0 32 32 0 1 0 64 0m288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64"/></svg>
                </div>
                <div v-if="project.project_source_type !== 'HESTIA'">
                    <p class="text-center text-xs" v-if="project.unit_lowest.unit_type.car_park === project.unit_highest.unit_type.car_park">{{ project.unit_lowest.unit_type.car_park }} car</p>
                    <p class="text-center text-xs" v-else>{{ project.unit_lowest.unit_type.car_park }} - {{ project.unit_highest.unit_type.car_park }} car</p>
                </div>
                <div v-else>
                    <p class="text-center text-xs" v-if="project_summary.min_car_park === project_summary.max_car_park">{{ project_summary.min_car_park }} car</p>
                    <p class="text-center text-xs" v-else>{{ project_summary.min_car_park }} - {{ project_summary.max_car_park }} car</p>
                </div>
            </b-col>
            <b-col cols="auto" class="text-center">
                <div class="circle">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 512 512"><path fill="currentColor" d="M.2 468.9C2.7 493.1 23.1 512 48 512h416c26.5 0 48-21.5 48-48v-96c0-26.5-21.5-48-48-48h-48v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80h-64v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80h-64v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80h-80c-8.8 0-16-7.2-16-16s7.2-16 16-16h80v-64h-80c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v416c0 1.7.1 3.3.2 4.9"/></svg>
                </div>
                <div v-if="project.project_source_type !== 'HESTIA'">
                    <p class="text-center text-xs" v-if="project.unit_lowest.built_up === project.unit_highest.built_up">{{ project.unit_lowest.built_up }} sqft</p>
                    <p class="text-center text-xs" v-else>{{ project.unit_lowest.built_up }} - {{ project.unit_highest.built_up }} sqft</p>
                </div>
                <div v-else>
                    <p class="text-center text-xs" v-if="project_summary.min_built_up === project_summary.max_built_up">{{ project_summary.min_built_up }} sqft</p>
                    <p class="text-center text-xs" v-else>{{ project_summary.min_built_up }} - {{ project_summary.max_built_up }} sqft</p>
                </div>
            </b-col>
        </b-row>
    </b-card>
</template>
<script>
import { Image } from 'element-ui'
import PreviewModal  from '@/components/Modal/PreviewModal'

export default {
    props: ['project', 'images'],
    components: {
        PreviewModal,
        [Image.name]: Image,
    },
    data() {
        return {
            failed: 'https://static.vecteezy.com/system/resources/previews/004/141/669/non_2x/no-photo-or-blank-image-icon-loading-images-or-missing-image-mark-image-not-available-or-image-coming-soon-sign-simple-nature-silhouette-in-frame-isolated-illustration-vector.jpg'
        }
    },
    computed: {
        project_summary() {
            if (!this.project || !this.project.unit_types || this.project.unit_types.length === 0) {
                return {
                    max_bed: null,
                    min_bed: null,
                    max_bath: null,
                    min_bath: null,
                    max_car_park: null,
                    min_car_park: null,
                    max_built_up: null,
                    min_built_up: null,
                };
            }

            const bedValues = this.project.unit_types.map(unit => unit.bedroom);
            const bathValues = this.project.unit_types.map(unit => unit.bathroom);
            const carParkValues = this.project.unit_types.map(unit => unit.car_park);
            const builtUpValues = this.project.unit_types.map(unit => parseFloat(unit.built_up));

            return {
                max_bed: Math.max(...bedValues),
                min_bed: Math.min(...bedValues),
                max_bath: Math.max(...bathValues),
                min_bath: Math.min(...bathValues),
                max_car_park: Math.max(...carParkValues),
                min_car_park: Math.min(...carParkValues),
                max_built_up: Math.max(...builtUpValues),
                min_built_up: Math.min(...builtUpValues),
            };
        }
    },
    methods: {
        developerName(project) {
            return project.project_developer?.name || 'N/A'
        },
        maxValueBed(units) {
            const bedValues = units.map(unit => unit.bedroom)
            return Math.max(...bedValues)
        },
        maxValueBath(units) {
            const bathValues = units.map(unit => unit.bathroom)
            return Math.max(...bathValues)
        },
        maxValueCarPark(units) {
            const carParkValues = units.map(unit => unit.car_park)
            return Math.max(...carParkValues)
        }
    }
}
</script>
<style scoped>
.circle {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #F6F9FD;
    border-radius: 50%;
    width: 40px;
    height: 40px;
}

.circle svg {
    width: 50%;
    height: 50%;
    color: #73839C;
}
</style>